// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","597":"component---src-pages-index-default-tsx"}[chunkId] + "-" + {"245":"7970299bf6cb46d42fe6","453":"6024740a4aaa2e8861bf","597":"bcb1e866d6ad6e5cce88"}[chunkId] + ".js";
};